@if (categories()?.length) {
  <div [ngClass]="textClass()">
    <div class="row g-2 mb-3" [ngClass]="rowClass()">
      @for (category of categories(); track $index) {
        <div class="col-auto">
          <img
            class="w-auto h-auto"
            aria-hidden="true"
            [style.max-width]="maxWidth()"
            [style.min-width]="maxWidth()"
            [src]="category | categoryIconSrc"
            alt=""
            data-test="product-category-img"
          />
        </div>
      }
    </div>
    @if (showHeadline()) {
      <mwe-headline
        [headlineNodeType]="textNodeType()"
        [text]="joinedLabels()"
        cssClass="mb-0 fw-bold text-secondary"
        [style]="'font-size:' + fontSize()"
        data-test="product-category-text"
      />
    }
  </div>
}
